if (!customElements.get('articles-by-market')) {
    class ArticlesByMarket extends HTMLElement {
        connectedCallback() {
            this.itemsPerPage = parseInt(this.dataset.itemsPerPage || 10);
            this.loadedAPIPage = 1;
            this.lastAPIPage = false;
            this.pages = { 1: [] };
            this.lastPageWithItems = 1;
            this.currentPage = 1;

            this.list = this.querySelector('[data-articles-list]') || this.querySelector('[data-recipes-list]');
            this.loadMoreButton = this.querySelector('[data-load-more]');
            this.emptyState = this.querySelector('[data-empty-state]');

            this.bindedLoadMoreHandler = this.handleLoadMore.bind(this);

            void this.init();
        }

        async init() {
            if (!this.list) {
                console.error('No articles list found in the component.');
                return;
            }

            try {
                this.showLoader();
                await this.fetchItems();
                this.renderItems();

                this.loadMoreButton?.addEventListener('click', this.bindedLoadMoreHandler);
            } catch (error) {
                console.error('Error initializing ArticlesByMarket:', error);
            } finally {
                this.hideLoader();
            }
        }

        async fetchItems() {
            const fetchUrl = new URL(window.location.href);
            if (fetchUrl.searchParams.get('page')) fetchUrl.searchParams.delete('page');
            fetchUrl.searchParams.set('section_id', 'api-articles-search-by-market')

            while (!this.lastAPIPage) {
                if (this.pages[this.currentPage]?.length >= this.itemsPerPage) break;

                try {
                    fetchUrl.searchParams.set('page', this.loadedAPIPage);
                    const response = await fetch(fetchUrl);
                    const html = await response.text();

                    if (html.includes('data-no-results')) {
                        this.lastAPIPage = true;
                        break;
                    }

                    if (!html.includes('data-empty-page')) {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');
                        const articles = doc.querySelectorAll('blog-post-card');
                        this.handleNewItems(articles);
                    }

                    this.lastAPIPage = html.includes('data-last-page');
                    this.loadedAPIPage++;
                } catch (error) {
                    console.error('Error fetching items:', error);
                    break;
                }
            }
        }

        handleNewItems(items) {
            items.forEach(item => {
                if (this.pages[this.lastPageWithItems]?.length >= this.itemsPerPage) {
                    this.lastPageWithItems++;
                    this.pages[this.lastPageWithItems] = [];
                }
                this.pages[this.lastPageWithItems].push(item);
            });
        }

        renderItems() {
            if (!this.pages[this.currentPage]?.length) { // last page
                this.loadMoreButton.remove();

                if (this.pages[1].length === 0) { // no results at all
                    this.emptyState.hidden = false;
                }

                return;
            }

            const fragment = document.createDocumentFragment();
            this.pages[this.currentPage].forEach(item => {
                const li = document.createElement('li');
                li.classList.add('js-pagination-result');
                li.appendChild(item);
                fragment.appendChild(li);
            });
            this.list.appendChild(fragment);

            if (this.lastAPIPage && this.currentPage >= this.lastPageWithItems) {
                this.loadMoreButton.remove();
            }
        }

        handleLoadMore() {
            this.currentPage++;

            if (this.lastAPIPage && this.currentPage === this.lastPageWithItems) { // last page
                this.renderItems();
                return;
            }

            if (this.pages[this.currentPage]?.length >= this.itemsPerPage) { // case when we have cached items for the next page
                this.renderItems();
                return;
            }

            if (!this.lastAPIPage) {
                this.showLoader();
                this.fetchItems()
                    .then(() => this.renderItems())
                    .catch(console.error)
                    .finally(() => this.hideLoader());
            }
        }

        showLoader() {
            this.loadMoreButton.classList.add('is-loading');
            this.loadMoreButton.setAttribute('aria-disabled', 'true');
        }

        hideLoader() {
            this.loadMoreButton.classList.remove('is-loading');
            this.loadMoreButton.removeAttribute('aria-disabled');
        }

        disconnectedCallback() {
            this.loadMoreButton.removeEventListener('click', this.bindedLoadMoreHandler);
        }
    }

    customElements.define('articles-by-market', ArticlesByMarket);
}